
// const baseURL = "http://175.29.21.7:8006";

// const baseURL = "https://octane.air2o.net";

const baseURL = "https://testhvacoctane.air2o.net"; 

export default baseURL;
